<template>
    <section
        class="bg-black-700 full-width relative phone:h-screen tabletLandscape:h-screen flex flex-col relative">
        <!--Image Background-->
        <background-image
            :src="getBlogPostProperty('featuredImage','src')"
            :srcset="getBlogPostProperty('featuredImage','srcSet')"
            :with-gradient="true"
        />

        <!--Content Layout in a Container-->
        <div
            class="container flex phone:flex-col phone:justify-end flex-grow z-10 pt-8 tablet:pt-16 pb-16 tablet:items-end">
            <!--Layout Spacer -- Matches Aside Text Component sizing/spacing-->
            <div class="hidden tablet:flex w-1/4 max-w-xxs mr-10 desktop:mr-32" />

            <!--Content Block  -->
            <div class="section-text-with-button flex flex-col items-start">
                <!--Article Meta Component-->
                <post-meta
                    :post-category="getBlogPostPropertyGroup('postCategory')"
                    :post-meta="getBlogPostPropertyGroup('postMeta')"
                    class="mb-10"
                />
                <!--Content Text Component-->
                <content-text>
                    <template #title-text>
                        <h2
                            class="font-bold tracking-tight leading-none"
                            v-text="getBlogPostProperty('postContent','title_1')" />
                    </template>

                    <template #subtitle-text>
                        <h3
                            class="font-light tracking-tight"
                            v-text="getBlogPostProperty('postContent','title_2')" />
                    </template>

                    <!-- Excerpt is shown on index pages only -->
                    <template
                        v-if="!showTeaser"
                        #content-text>
                        <div
                            class="font-regular mb-6"
                            v-text="getBlogPostProperty('postContent','excerpt')" />
                    </template>

                    <!-- Teaser is shown on post page-->
                    <template
                        v-if="showTeaser && getBlogPostProperty('postContent','teaser')"
                        #content-text>
                        <div class="teaser-quote relative mb-12 mt-12 pl-4 border-l border-white  ">
                            <svg-icon
                                class="quotes-icon absolute phone:left-0 phone:-mt-10 -ml-12 top-0"
                                icon="quotes" />
                            <p
                                class="teaser italic font-bold phone:text-sm text-lg"
                                v-text="getBlogPostProperty('postContent','teaser')" />
                        </div>
                    </template>
                </content-text>

                <!-- CTA button - now shown with teaser-->
                <tis-button
                    v-if="!showTeaser"
                    :full-redirect="true"
                    :url="getBlogPostProperty('postMeta', 'url')"
                    class="btn-gold block text-sm"
                >
                    {{ labels.btnReadPost }}
                    <svg-icon
                        class="w-7 h-6 inline-block ml-3"
                        icon="arrow-horizontal" />
                </tis-button>
            </div>
        </div>
    </section>
</template>

<script>
import ContentText from '@web/components/ContentText';
import BackgroundImage from '@web/components/BackgroundImage';
import TisButton from '@whisper/components/buttons/TisButton';
import PostMeta from '@web/components/Blog/PostMeta';
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { get } from 'lodash';

export default {
  components: {
    TisButton,
    SvgIcon,
    BackgroundImage,
    PostMeta,
    ContentText,
  },
  props: {
    labels: {
      type: Object,
      required: false,
    },
    blogPost: {
      type: Object,
      required: true,
    },
    showTeaser: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    getBlogPostProperty(group, property) {
      return get(this, ['blogPost', group, property]);
    },
    getBlogPostPropertyGroup(group) {
      return get(this, ['blogPost', group]);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
